module.exports = __webpack_public_path__ + "static/img/Home06@2x.165ea0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home06@2x.png
// module id = mZiM
// module chunks = 1